// extracted by mini-css-extract-plugin
export var wrapper = "Footer-module--wrapper--iPs-R";
export var content = "Footer-module--content--ZuS6O";
export var inner = "Footer-module--inner--iC326";
export var links = "Footer-module--links--DPazo";
export var link = "Footer-module--link--lQ+eR";
export var copyright = "Footer-module--copyright--Oaz4y";
export var bryoz = "Footer-module--bryoz--btCdI";